import { FC, ReactNode } from 'react'
import { Box, Button, colors, styled } from '@mui/material'
import { IFormBase } from './types'

export const formGridLayoutClasses = {
  root: 'DinoFormGridLayout-root',
  form: 'DinoFormGridLayout-form',
  bottomBar: 'DinoFormGridLayout-bottomBar',
  // status
  autoHeight: 'DinoFormGridLayout-autoHeight'
}

export const FormGridLayoutStyled = styled(Box)(({ theme }) => ({
  padding: theme.spacing(2, 1.5, 0),
  maxHeight: `calc(100vh - ${48 * 2 + 12 * 2}px)`,
  overflowY: 'auto',
  overflowX: 'hidden',
  [`&.${formGridLayoutClasses.autoHeight}`]: {
    maxHeight: 'none',
    height: 'fit-content',
    overflow: 'visible'
  }
}))

export interface IFormBottomBarProps<T> extends IFormBase<T> {
  before?: ReactNode
}

export function CreateFormBottomBar<T>() {
  const FormBottomBar: FC<IFormBottomBarProps<T>> = (props) => (
    <FormBottomBarWrap className={formGridLayoutClasses.bottomBar}>
      <Box sx={{ flex: 1 }}>{props.before}</Box>
      <Button variant='contained' type='submit' size='small'>
        Submit
      </Button>
    </FormBottomBarWrap>
  )
  return FormBottomBar
}

export const FormBottomBarWrap = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  padding: '0 12px',
  boxShadow: 'rgba(145, 158, 171, 0.2) 0px 0px 2px 0px,rgba(145, 158, 171, 0.12) 0px 12px 24px -4px',
  position: 'sticky',
  bottom: 0,
  backgroundColor: theme.palette.background.paper,
  zIndex: 1,
  height: '48px'
}))
